// TODO [SCMPWEB-9518]: Remove after Proteus A/B test ends
import type { FunctionComponent, ReactNode } from "react";
import { useMemo } from "react";
import type { GraphQLTaggedNode, PreloadedQuery } from "react-relay";
import { usePreloadedQuery } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import type { hooksProteusTopStoriesQuery } from "scmp-app/queries/__generated__/hooksProteusTopStoriesQuery.graphql";
import type { topStoriesHomeV2QueueItemsEdge$key } from "scmp-app/queries/__generated__/topStoriesHomeV2QueueItemsEdge.graphql";

import { HERO_TOP_STORIES_COUNT } from "./constants";

type Props = {
  children: (topStoriesEdges: topStoriesHomeV2QueueItemsEdge$key) => ReactNode;
  heroTailEdges: ReadonlyArray<unknown>;
  proteusQueryReference: PreloadedQuery<hooksProteusTopStoriesQuery>;
  proteusTopStoriesQueryNode: GraphQLTaggedNode;
};

const HomeV2WithProteusRefetch: FunctionComponent<Props> = ({
  children,
  heroTailEdges,
  proteusQueryReference,
  proteusTopStoriesQueryNode,
}) => {
  const proteusData = usePreloadedQuery(proteusTopStoriesQueryNode, proteusQueryReference);
  const proteusTopStoriesEdges = useMemo(
    () =>
      (
        (proteusData.proteusTopStories?.items?.edges ?? [])
          .filter(notEmpty)
          .filter(edge => notEmpty(edge.node)) as unknown as topStoriesHomeV2QueueItemsEdge$key[]
      ).slice(HERO_TOP_STORIES_COUNT, 18),
    [proteusData.proteusTopStories?.items?.edges],
  );
  const mergedEdges = useMemo(
    () =>
      [
        ...heroTailEdges,
        ...(proteusTopStoriesEdges as unknown as ReadonlyArray<unknown>),
      ] as unknown as topStoriesHomeV2QueueItemsEdge$key,
    [heroTailEdges, proteusTopStoriesEdges],
  );
  return <>{children(mergedEdges)}</>;
};

HomeV2WithProteusRefetch.displayName = "HomeV2WithProteusRefetch";

export { HomeV2WithProteusRefetch };
